import { MessageCircle } from "lucide-react";

const WhatsAppChat = () => {
  const phoneNumber = "917862878915";

  return (
    <a
      href={`https://wa.me/${phoneNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 bg-primary1 text-white p-3 rounded-full shadow-lg hover:bg-green-600 transition flex items-center"
    >
      <MessageCircle className="w-8 h-8" />
    </a>
  );
};

export default WhatsAppChat;
